import * as React from "react";

const SvgTshapedPolygon = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="221.14"
    fill="none"
    viewBox="0 0 140 90"
    {...props}
  >
          <path
          d="M135 5v47.005h-35V85H40V52.005H5V5z"
      fill="none"
      stroke="black"
      strokeWidth="11"
    />
    <path
      fill="#D7EAFF"
      stroke={rackColor}
      strokeWidth="9"
      d="M135 5v47.005h-35V85H40V52.005H5V5z"
    ></path>
  
  </svg>
);

export default SvgTshapedPolygon;
